module.exports = __webpack_public_path__ + "static/media/predestinado_p.aa2671ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/predestinado_p.png
// module id = 1168
// module chunks = 0